import {Table, TableBody, TableHead, Typography} from '@mui/material';
import React from 'react';
import {
  StyledBodyCell,
  StyledHeadCell,
  StyledTableRow,
  StyledSkeleton,
} from '../components';
import {firstColWidth} from '../constants';

export function LoadingWorkbookTable() {
  return (
    <Table>
      <TableHead>
        <StyledTableRow>
          <StyledBodyCell />
          <StyledBodyCell />
          {Array.from({length: 5}).map((_, idx) => (
            <StyledHeadCell key={`head1-${idx}`}>
              <StyledSkeleton />
            </StyledHeadCell>
          ))}
        </StyledTableRow>
        <StyledTableRow>
          <StyledBodyCell rowSpan={2} />
          <StyledBodyCell />
          {Array.from({length: 5}).map((_, idx) => (
            <StyledBodyCell key={`head1-${idx}`}>
              <StyledSkeleton />
            </StyledBodyCell>
          ))}
        </StyledTableRow>
        <StyledTableRow>
          <StyledBodyCell />
          {Array.from({length: 5}).map((_, idx) => (
            <StyledBodyCell key={`head1-${idx}`}>
              <StyledSkeleton />
            </StyledBodyCell>
          ))}
        </StyledTableRow>
        <StyledTableRow>
          <StyledBodyCell />
          <StyledBodyCell>
            <Typography sx={{fontWeight: 'bold'}}>Difference</Typography>
          </StyledBodyCell>
          {Array.from({length: 5}).map((_, idx) => (
            <StyledBodyCell key={`head1-${idx}`}>
              <StyledSkeleton />
            </StyledBodyCell>
          ))}
        </StyledTableRow>
      </TableHead>
      <TableBody>
        {Array.from({length: 10}).map((_, idx) => (
          <StyledTableRow key={`tablebodyrow-${idx}`}>
            <StyledBodyCell
              sx={{
                left: 0,
                width: firstColWidth,
                minWidth: firstColWidth,
                maxWidth: firstColWidth,
              }}
            >
              <StyledSkeleton />
            </StyledBodyCell>
            <StyledBodyCell sx={{width: '100px'}}>
              <StyledSkeleton />
            </StyledBodyCell>
            {Array.from({length: 5}).map((_, idx) => (
              <StyledBodyCell key={`head1-${idx}`}>
                <StyledSkeleton />
              </StyledBodyCell>
            ))}
          </StyledTableRow>
        ))}
      </TableBody>
    </Table>
  );
}
